export default __webpack_public_path__ + "static/media/consentLetterHeaderImg.117c9220.jpg";